module.exports = __webpack_public_path__ + "static/nipcbestfriends1-7d7207c5e4498b0a74559f69235a29df.jpeg";